module.exports = __webpack_public_path__ + "img/AddPosHelp1.a1b6f46c.png";